<template>
    <b-col :sm="12" :md="12" :lg="4">
        <b-form-group :label="label" label-for="campanha-input" label-class="font_size_label">
            <validation-provider #default="{ errors }" name="campanha" rules="required">
                <v-select id="select-campanha" v-model="modelValue" variant="custom" :label="optionLabel"
                    :placeholder="placeholder" :clearable="clearable" :values="options" :options="options"
                    :loading="loading" @input="onInput">
                    <span slot="no-options">Nenhuma opção selecionável.</span>
                </v-select>
                <small v-if="errors[0]" class="text-danger">
                    Este campo é de preenchimento obrigatório.
                </small>
            </validation-provider>
        </b-form-group>
        <div class="mb-1 d-flex justify-content-end">
            <b-form-checkbox v-model="showCompleted" name="check-button"
                @change="$emit('change-completed', showCompleted)">
                Incluir campanhas concluídas
            </b-form-checkbox>
        </div>
    </b-col>
</template>

<script>
import { BCol, BFormGroup, BFormCheckbox } from "bootstrap-vue";
import { ValidationProvider } from "vee-validate";
import vSelect from "vue-select";

export default {
    name: "CampaignSelect",
    components: { BCol, BFormGroup, BFormCheckbox, ValidationProvider, vSelect },
    props: {
        label: { type: String, default: "Campanha*" },
        placeholder: { type: String, default: "Selecione uma campanha" },
        optionLabel: { type: String, default: "descricao" },
        options: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
        clearable: { type: Boolean, default: false },
        value: { type: [Object, String, Number], default: null },
        showCompletedCampaigns: { type: Boolean, default: false },
    },
    data() {
        return {
            modelValue: this.value,
            showCompleted: this.showCompletedCampaigns,
        };
    },
    watch: {
        value(newVal) {
            this.modelValue = newVal;
        },
        modelValue(newVal) {
            this.$emit("input", newVal);
        },
        showCompletedCampaigns(newVal) {
            this.showCompleted = newVal;
        },
        showCompleted(newVal) {
            this.$emit("update:showCompletedCampaigns", newVal);
        },
    },
    methods: {
        onInput(val) {
            this.$emit('input', val);
            this.$nextTick(() => {
                this.$emit('selected', val);
            });
        }
    },
};
</script>
